import React, { useEffect, useState } from "react";
import {
  decrypt,
  encrypt,
  toAbsoluteUrl,
  toasterrormsg,
  toastsuccessmsg,
} from "../../helpers/Reusable";
import { FaMagnifyingGlass } from "react-icons/fa6";
import { apiHeader, getData, postData } from "../../helpers/ApiHelper";
import { useLocation } from "react-router-dom";
import { IoClose } from "react-icons/io5";
import * as Yup from "yup";
import { useFormik } from "formik";
import ClipLoader from "react-spinners/ClipLoader";
import { ToastContainer } from "react-toastify";
import {
  deleteCookie,
  getCookie,
  setCookie,
} from "../../helpers/CookieComponent";
import {
  FacebookShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
} from "react-share";
import { Helmet } from "react-helmet-async";

// Formik InitialValues
const initialValues = {
  email: "",
  fullName: "",
  comment: "",
  status: "0",
};

// Fromik Validation Schema
const schema = Yup.object().shape({
  email: Yup.string()
    .trim()
    .required("Email is required")
    .matches(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      "Email is not valid"
    ),
  fullName: Yup.string().trim().required("Full name is required"),
  comment: Yup.string().trim().required("Comment is required"),
});

const ViewArticle = () => {
  const articleCategoryId = getCookie("articleCategoryId");
  const [searchMenu, setSearchMenu] = useState(articleCategoryId);
  const [articleData, setArticleData] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchCategory, setSearchCategory] = useState("");
  const [articleCategoryList, setArticleCategoryList] = useState([]);
  // const articleId = getCookie("articleId");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const articleId = decrypt(searchParams.get("art"));
  const encodeShareId = encodeURIComponent(searchParams.get("art"));
  const shareLink = `https://web.xpertlab.com/naruto/gcc-law-help/viewarticle?art=${encodeShareId}`;

  const linkShare = window.location.href;
  console.log("articleData??????????????", articleData);

  // // Dynamic share link using current URL
  // const [shareLink, setShareLink] = useState("");

  // useEffect(() => {
  //   // Set the share link to the current URL
  //   const currentUrl = window.location.href;
  //   setShareLink(currentUrl);
  // }, [location]);

  useEffect(() => {
    setSearchMenu(articleCategoryId);
  }, [articleCategoryId]);

  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);

      const param = {
        email: values.email,
        lastName: values.fullName,
        comment: values.comment,
        articleId: articleId,
        status: String(values.status),
      };

      const response = await postData(
        "private/article/replay/add",
        param,
        apiHeader(false)
      );
      console.log(response);

      if (
        String(response?.status) == "200" &&
        String(response?.data.status) == "200"
      ) {
        toastsuccessmsg(response.data.message);
        setTimeout(() => {
          setLoading(false);
          resetForm();
          closeModal();
        }, 1500);
      } else {
        console.log(response.data.message);
        toasterrormsg(response.data.message);
        setLoading(false);
      }
    },
  });

  // Article View API Call
  const getUserDetails = async () => {
    var response = await getData(
      "private/article/replay/user/detail",
      {},
      apiHeader(false)
    );
    console.log(response, "UserDetails");

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data;
      formik.setValues({
        email: data.email || "",
        fullName: data.lastName || "",
        comment: "",
        status: data.status,
      });
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };
  useEffect(() => {
    if (isModalOpen) {
      getUserDetails();
    }
  }, [isModalOpen]);

  // Article View API Call
  const viewArticle = async (id) => {
    const param = {
      articleId: id,
    };
    var response = await postData("article/detail", param, apiHeader(false));

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data[0];
      setArticleData(data);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewArticle(articleId);
  }, [articleId]);

  // Article Category View API Call
  const viewArticleCategory = async (search) => {
    const param = {
      term: search,
      offset: 0,
      limit: 0,
      sort: "",
      sortBy: "",
    };
    var response = await postData(
      "article/category/list",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      setArticleCategoryList(data);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewArticleCategory(searchCategory);
  }, [searchCategory]);

  const searchList = [
    {
      name: "Account",
    },
    {
      name: "FEMA & Banking",
    },
    {
      name: "Advisory",
    },
    {
      name: "GST & Customs",
    },
    {
      name: "Finance Act",
    },
    {
      name: "Company Law",
    },
  ];

  const openModal = () => {
    document.body.style.overflowY = "hidden";
    setIsModalOpen(true);
  };
  const closeModal = () => {
    document.body.style.overflowY = "";
    setIsModalOpen(false);
    formik.resetForm();
  };

  return (
    <>
      <Helmet>
        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="GCC Law Help Article" />
        <meta
          property="og:description"
          content="Read this insightful legal article on GCC Law Help."
        />
        <meta property="og:url" content={linkShare} />
        <meta property="og:type" content="article" />
        <meta
          property="og:image"
          content={toAbsoluteUrl("media/img/logo/main-logo.svg")}
        />
      </Helmet>
      <ToastContainer />
      {isModalOpen === true && (
        <>
          <div
            onClick={closeModal}
            className={`w-full fixed top-0 left-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()} // Prevents click inside modal from closing it
              className="w-[90%] md:w-[80%] lg:w-[60%] xl:container p-[4%] lg:p-[2%] mx-auto my-[5%] lg:my-0 relative top-[10%] lg:top-1/2 transform lg:-translate-y-1/2 form-box"
            >
              <div className="flex items-center justify-between">
                <h1 className="mb-[3%] hanson">Leave a reply</h1>
                <IoClose
                  onClick={closeModal}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <div className="">
                <form onSubmit={formik.handleSubmit}>
                  <div className="w-full grid lg:grid-cols-2 gap-[2rem] mb-[7rem]">
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Email
                      </label>
                      <input
                        className="w-full form-input"
                        type="email"
                        placeholder="Enter Email"
                        id="email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                      />
                      {formik.touched.email && formik.errors.email && (
                        <div className="mt-4 error-msg">
                          <div className="">{formik.errors.email}</div>
                        </div>
                      )}
                    </div>
                    <div className="w-full flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label required mb-4"
                      >
                        Full Name
                      </label>
                      <input
                        className="w-full form-input"
                        type="text"
                        placeholder="Enter Full Name"
                        id="fullName"
                        value={formik.values.fullName}
                        onChange={formik.handleChange}
                      />
                      {formik.touched.fullName && formik.errors.fullName && (
                        <div className="mt-4 error-msg">
                          <div className="">{formik.errors.fullName}</div>
                        </div>
                      )}
                    </div>
                    <div className="w-full lg:col-span-2 flex flex-col">
                      <label
                        htmlFor=""
                        className="w-full form-input-label mb-4 required"
                      >
                        Comment
                      </label>
                      <textarea
                        placeholder="Enter Comment"
                        type="text"
                        className="w-full form-input"
                        id="comment"
                        value={formik.values.comment}
                        onChange={formik.handleChange}
                        rows={3}
                      />
                      {formik.touched.comment && formik.errors.comment && (
                        <div className="mt-4 error-msg">
                          <div className="">{formik.errors.comment}</div>
                        </div>
                      )}
                    </div>
                    <div className="w-full lg:col-span-2">
                      <label
                        htmlFor="status"
                        className="flex items-start gap-5 cursor-pointer"
                      >
                        <input
                          type="checkbox"
                          id="status"
                          name="status"
                          checked={formik.values.status == "1"}
                          onChange={(e) =>
                            formik.setFieldValue(
                              "status",
                              e.target.checked ? "1" : "0"
                            )
                          }
                          className={`w-[2rem] h-[2rem] accent-green-600`}
                        />
                        <span className="form-input-label">
                          Save my name, email, and website in this browser for
                          the next time i comment.
                        </span>
                      </label>
                    </div>
                  </div>
                  <div className="w-full justify-center gap-5 flex">
                    <button
                      type="submit"
                      className="btn-submit"
                      disabled={loading}
                    >
                      {!loading && <>Post comment</>}
                      {loading && (
                        <div className="flex items-center gap-3">
                          <span className="" style={{ display: "block" }}>
                            Please wait...{" "}
                          </span>
                          <ClipLoader
                            color={"#ffffff"}
                            loading={loading}
                            size={20}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      )}
      <div className="w-full p-[5%] min-h-screen bg-yellow">
        <div className="xl:container mx-auto">
          <div className="w-full mb-[3%] md:mb-[2%]">
            <h1 className="hanson text-center mb-[1%] heading">Article</h1>
            <img
              className="mb-[2%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
              alt=""
            />
          </div>
          <div className="w-full mb-[5%] flex gap-10 lg:flex-row flex-col section-view-article">
            <div className="sva-part1">
              <div className="w-full pb-[2%] mb-[2%] svap1-part1">
                <h1 className="xl:w-[70%] mb-[2%] svap1p1-title">
                  {articleData && articleData.title}
                </h1>
                <div className="mb-[2%] flex flex-col gap-2 sm:gap-0 sm:flex-row md:items-center">
                  <div className="w-max flex items-center">
                    <div className="w-max leading-none flex items-center pr-[1rem] svap1p1-details">
                      <h1 className="w-max svap1p1d-t1">5 mins read</h1>
                    </div>
                    <div className="w-max flex md:items-center border-r-0 sm:border-r-[1px] gap-1 px-[1rem] leading-none svap1p1-details">
                      <h1 className="w-max svap1p1d-t1">Delivered at:</h1>
                      <h1 className="w-max  svap1p1d-t2 svap1p1d-t1">
                        {" "}
                        {articleData && articleData.deliveredAt}
                      </h1>
                    </div>
                  </div>
                  <div className="w-max flex items-center">
                    <div className="w-max flex md:items-center gap-1 pr-[1rem] sm:px-[1rem] leading-none svap1p1-details">
                      <h1 className="w-max svap1p1d-t1">Author:</h1>
                      <h1 className="w-max  svap1p1d-t2 svap1p1d-t1">
                        {articleData && articleData.author}
                      </h1>
                    </div>
                    <div className="w-max flex md:items-center border-r-0 gap-1 px-[1rem] leading-none svap1p1-details">
                      <h1 className="w-max svap1p1d-t1">Last update</h1>
                      <h1 className="w-max svap1p1d-t2 svap1p1d-t1">
                        {articleData && articleData.publishDate}
                      </h1>
                    </div>
                  </div>
                </div>
                <div className="mb-[5%]">
                  <img
                    className="w-full h-[40vw] md:h-[40vw]"
                    src={articleData && articleData.articleDocument}
                    alt="GCC Law Help Workplace Image"
                  />
                </div>
                <div className="flex flex-col gap-5">
                  {/* <p className="break-words sva-para">
                    {articleData && articleData.description}
                  </p> */}
                  <div
                    className="break-words sva-para"
                    dangerouslySetInnerHTML={{
                      __html: articleData && articleData.description,
                    }}
                  />
                </div>
              </div>
              <div className="w-full svap1-part2">
                <h1 className="mb-[2%] sav1p2-title">Share by</h1>
                <div className="flex items-center gap-[2rem]">
                  {/* Facebook Share */}
                  {/* <a
                    href={`https://www.facebook.com/sharer/sharer.php?u=https://web.xpertlab.com/naruto/gcc-law-help/viewarticle?art=BgSVYLdLb2zJG%2B4%2F4s6tDgsp3ppatquX4364EFG60mQ`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="w-[2.5rem] h-[2.5rem]"
                      src={toAbsoluteUrl("media/img/icon/basic/facebook.svg")}
                      alt="GCC Law Facebook"
                    />
                  </a> */}

                  <FacebookShareButton url={linkShare} className="flex">
                    <img
                      className="w-[2.5rem] h-[2.5rem]"
                      src={toAbsoluteUrl("media/img/icon/basic/facebook.svg")}
                      alt="GCC Law Facebook"
                    />
                  </FacebookShareButton>

                  {/* LinkedIn Share */}
                  {/* <a
                    href={`https://www.linkedin.com/shareArticle?mini=true&url=https://web.xpertlab.com/naruto/gcc-law-help/viewarticle?art=BgSVYLdLb2zJG%2B4%2F4s6tDgsp3ppatquX4364EFG60mQ`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="w-[2.5rem] h-[2.5rem]"
                      src={toAbsoluteUrl(
                        "media/img/icon/social-media/Linkedin2.svg"
                      )}
                      alt="GCC Law LinkedIn"
                    />
                  </a> */}
                  <LinkedinShareButton url={linkShare} className="flex">
                    <img
                      className="w-[2.5rem] h-[2.5rem]"
                      src={toAbsoluteUrl(
                        "media/img/icon/social-media/Linkedin2.svg"
                      )}
                      alt="GCC Law LinkedIn"
                    />
                  </LinkedinShareButton>

                  {/* WhatsApp Share */}
                  {/* <a
                    href={`https://wa.me/?text=${shareLink}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className="w-[3rem] h-[3rem]"
                      src={toAbsoluteUrl(
                        "media/img/icon/social-media/Whatsapp2.svg"
                      )}
                      alt="GCC Law WhatsApp"
                    />
                  </a> */}
                  <WhatsappShareButton url={linkShare} className="flex">
                    <img
                      className="w-[3rem] h-[3rem]"
                      src={toAbsoluteUrl(
                        "media/img/icon/social-media/Whatsapp2.svg"
                      )}
                      alt="GCC Law WhatsApp"
                    />
                  </WhatsappShareButton>
                </div>
              </div>
            </div>
            {/* <div className="lg:w-[35%] sva-part2">
              <h1 className="mb-[2%] svap2-title">Search Blog</h1>
              <div className="relative w-full mb-[7%] svap2-input-main">
                <div className="w-[10%] h-full absolute  top-0 left-0 flex items-center justify-center">
                  <FaMagnifyingGlass className="svap2-search" />
                </div>
                <input
                  className="w-full py-[2%] pl-[10%] pr-[2rem] svap2-search"
                  type="text"
                  placeholder="Search"
                  onChange={(e) => setSearchCategory(e.target.value)}
                />
              </div>
              <div className="w-full flex flex-col gap-5">

                {articleCategoryList &&
                  articleCategoryList.map((data) => (
                    <div
                      className="w-full p-[2%] flex justify-items-center cursor-pointer svap2-box"
                      onClick={() => setSearchMenu(data._id)}
                    >
                      <div
                        className={
                          searchMenu === data._id
                            ? "w-full h-full p-[2%] cursor-pointer svap2-name svap2-name-active"
                            : "w-full h-full p-[2%] cursor-pointer svap2-name"
                        }
                      >
                        <h1>{data.categoryName}</h1>
                      </div>
                    </div>
                  ))}
              </div>
            </div> */}
          </div>
          <div className="w-full flex items-center justify-center">
            <button
              onClick={openModal}
              className="px-[5rem] py-[2rem] btn-leave"
            >
              Leave reply
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewArticle;
